import { z } from "zod";

// ── Fundraising response (API → frontend) ──

export const FundraisingResponseSchema = z.object({
    id: z.uuid(),
    amount: z.number(),
    currency: z.string(),
    close_month: z.number().int().min(1).max(12),
    close_year: z.number().int(),
    created_at: z.string(),
    updated_at: z.string(),
});
export type FundraisingResponse = z.infer<typeof FundraisingResponseSchema>;

export const FundraisingListResponseSchema = z.object({
    success: z.boolean(),
    data: z.array(FundraisingResponseSchema),
});

export const FundraisingDetailResponseSchema = z.object({
    success: z.boolean(),
    data: FundraisingResponseSchema,
});

// ── Create / Update bodies ──

export const CreateFundraisingRequestSchema = z.object({
    amount: z.number().min(0.01, "Amount must be positive"),
    currency: z.string().min(1).max(10),
    close_month: z.number().int().min(1).max(12),
    close_year: z.number().int().min(2020).max(2100),
});
export type CreateFundraisingRequest = z.infer<typeof CreateFundraisingRequestSchema>;

export const UpdateFundraisingRequestSchema = CreateFundraisingRequestSchema.partial();
export type UpdateFundraisingRequest = z.infer<typeof UpdateFundraisingRequestSchema>;

// ── Latest fundraising for dashboard ──

export const LatestFundraisingResponseSchema = z.object({
    success: z.boolean(),
    data: FundraisingResponseSchema.nullable(),
});
